import { bl_inv_stock_conversion_job_order_link_RowClass } from '../../../dbschema/bl_inv_stock_conversion_job_order_link.model';
import {BaseContainerModel} from '../../base-container.model';


export class StockConversionJobOrderModel extends BaseContainerModel {
  bl_inv_stock_conversion_job_order_link: bl_inv_stock_conversion_job_order_link_RowClass = new bl_inv_stock_conversion_job_order_link_RowClass();
}
